import {Routes} from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'buy-sheet-view',
        pathMatch: 'full'
    },
    {
        path: '',
        loadChildren: () => import('./modules').then(m => m.BuySheetModule),
        // canActivate: [AuthGuard]
    },
    {
        path: '',
        loadChildren: () => import('./modules').then(m => m.PcuUpdateModule),
        // canActivate: [AuthGuard]
    },
    {
        path: 'packaging',
        loadChildren: () => import('./modules').then(m => m.PackagingModule),
        // canActivate: [AuthGuard]
    },
    {
        path: 'report',
        loadChildren: () => import('./modules').then(m => m.ReportModule),
        // canActivate: [AuthGuard]
    },


];
